import * as React from 'react';
import { cn } from '@heroui/react';
import type { QuizOption } from './types';

export interface OptionButtonProps {
  option: QuizOption;
  index: number;
  isSelected: boolean;
  isRevealed: boolean;
  isCorrectAnswer: boolean;
  isWrongSelection: boolean;
  disabled?: boolean;
  onSelect: () => void;
}

export function OptionButton({
  option,
  index,
  isSelected,
  isRevealed,
  isCorrectAnswer,
  isWrongSelection,
  disabled,
  onSelect,
}: OptionButtonProps) {
  const letter = String.fromCharCode(65 + (index % 26));
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        'flex w-full items-center gap-4 rounded-xl border px-4 py-3 text-left transition-all',
        'border-white/15 bg-white/5 text-white backdrop-blur-sm',
        isSelected && !isRevealed && 'border-indigo-400/60 bg-indigo-500/20 shadow-[0_0_20px_rgba(99,102,241,0.25)]',
        isRevealed && isCorrectAnswer && 'border-emerald-400/60 bg-emerald-500/15',
        isRevealed && isWrongSelection && 'border-red-400/50 bg-red-500/10'
      )}
    >
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-white/10 font-mono text-sm font-bold text-white/90">
        {letter}
      </span>
      <span className="flex-1 text-sm font-medium leading-snug md:text-base">{option.text}</span>
    </button>
  );
}
